import Service from '../../Services/Service'

const LandingPageAPI = {
    getBannerBg() {
        return Service.get(`/site/landing_page`);
    }
};

export default LandingPageAPI;
